import { NETWORK, STATIC_DOMAIN, PLAYNC_DOMAIN, PURPLE_SCHEME } from "../common/const";

class PurpleUrl {
    constructor() {
    }

    goErrorPage(env) {
        const locale = window?.userData?.locale;
        const errorPageEnv = env === NETWORK.stage || env === NETWORK.live ? NETWORK.live : NETWORK.rc;
        location.href = `${STATIC_DOMAIN[errorPageEnv]}/purple/launcher/error.html?location=${locale}`;
    }

    getSsoUrl({ url, env, callback }) {
        if(!url) {
            return url;
        }

        const curEnv = env in PLAYNC_DOMAIN ? env : 'live';
        const encodeUrl = this.getEncodeUrl(url);

        fetch(`${PLAYNC_DOMAIN[curEnv]}/api/session/sso?return_url=${encodeUrl}`, {
            method: 'GET',
            credentials: 'include'
        })
        .then(async res => {
            const { ssoUrl } = await res?.json() || {};

            if(!ssoUrl) {
                throw new Error(`sso url이 존재하지 않습니다.${e}`);
            }
            
            const ssoUrlAddParam = this.setFromPurpleParam(ssoUrl);
            typeof callback === 'function' && callback(ssoUrlAddParam);
        })
        .catch(e => { throw new Error(`sso url api 호출에 실패하였습니다.\n${e}`); });
    }

    getIsEncoded(url) {
        return decodeURIComponent(url) !== url;
    }

    getEncodeUrl(url) {
        return !this.getIsEncoded(url) ? encodeURIComponent(url) : url;
    }

    setPurpleAppScheme(type, url) {
        if(!!url && type in PURPLE_SCHEME) {
            const encodeUrl = this.getEncodeUrl(url);
            url = `${PURPLE_SCHEME[type]}${encodeUrl}`;
        }

        return url;
    }

    setFromPurpleParam(url) {
        if(!url) {
            return url;
        }

        const hasParam = (/\?.+/g).test(url); // query param 있는지 여부
        const hasParams = (/\?(?=.*&).+/g).test(url); // param 2개 이상 있는지 여부

        return `${url}${!hasParam ? '?' : ''}${hasParams ? '&' : ''}from=purple`;
    }
}

export default new PurpleUrl();